let settings = null

const loadSettings = async (hostname, language) => {
	let loaded = null

	if (/localhost/i.test(hostname))
		loaded = await import('./envs/local')
	else if (/[.|-]uat[.|-]/i.test(hostname))
		loaded = await import('./envs/uat')
	else
		loaded = await import('./envs/prod')

	settings = { ...loaded, language }
}

export { settings, loadSettings }